import { render } from "./LegalView.vue?vue&type=template&id=0247b236&scoped=true"
import script from "./LegalView.vue?vue&type=script&lang=js"
export * from "./LegalView.vue?vue&type=script&lang=js"

import "./LegalView.vue?vue&type=style&index=0&id=0247b236&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0247b236"]])

export default __exports__